import React from "react";
import "./Surrounding.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Surroundingimages from "../../Media/Surrounding/Surrounding";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281188083575&text=Halo%20Thobie,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Serpong%20(Surrounding%20Area)%20https://marketing-gadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="surrounding" className="surrounding">
      <div className="container-fasilitas">
        <h1>Summarecon Serpong Surounding Area</h1>
        <hr color="#576F66" />
        <div className="container-desk">
          <div className="desksurrounding">
            Rasakan kemudahan hidup dengan beragam fasilitas lengkap di sekitar
            Anda—mulai dari pusat perbelanjaan, sekolah unggulan, layanan
            kesehatan, hingga taman hijau dan area olahraga. Semua tersedia
            dalam satu kawasan terpadu, ideal untuk keluarga modern yang
            mendambakan kualitas hidup terbaik.
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>&nbsp;&nbsp;Al Azhar BSD</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Pelita Harapan University
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Binus University
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Mitra Keluarga Hospital
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Mayapada Hospital
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Summarecon Mall Serpong
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>&nbsp;&nbsp;Ocean Park BSD</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>&nbsp;&nbsp;Akses Tol</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Living World Mall
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="slider-regia">
        <Slider {...settings1}>
          {Surroundingimages.map((image, index) => (
            <img className="imagecard" key={index} src={image} alt={image} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default About;
